var _rect, _g, _g2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiteraW(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Litera_W",
    "data-name": "Litera W",
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 125,
    height: 125,
    rx: 62.5,
    fill: "#f6cf85"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_49419_",
    transform: "translate(11.401 18.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3405_",
    d: "M149.95,224.513,150,205.96l57.663,20.03-.045,18.568Z",
    transform: "translate(-149.361 -167.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3382_",
    transform: "translate(53.328 7.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3401_",
    d: "M185.25,185.59v19.051l32.063,9.661,4.788-4.25-20.812-20.6Z",
    transform: "translate(-184.676 -184.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3402_",
    d: "M217.658,215.157l-32.788-9.887v-19.8l.483-.286,16.417,3.949,21.37,21.13Zm-31.625-10.746,31.338,9.45,4.078-3.632-20.268-20.045-15.163-3.647v17.875Z",
    transform: "translate(-184.87 -185.18)",
    fill: "#0c1859"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3381_",
    transform: "translate(40.4 27.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3397_",
    d: "M183.8,199.08,221.675,213.5l-.06,18.568-44.8-15.644Z",
    transform: "translate(-176.05 -198.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3398_",
    d: "M221.936,232.953,176.31,217.038l7.416-18.448.529.2L222.51,213.36l-.045,19.292ZM177.85,216.329,221.3,231.491l.045-17.347-36.972-14.077Z",
    transform: "translate(-176.31 -198.59)",
    fill: "#0c1859"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3383_",
    transform: "translate(27.004 22.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3183_",
    d: "M167.82,195.66v21.733l22.609,6.586,10.164.573-2.054-11.108Z",
    transform: "translate(-167.246 -194.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3394_",
    d: "M201.5,225.393l-10.9-.618-23.153-6.722v-22.5l.589-.332,31.248,18.086Zm-32.909-8.2,22.186,6.466,9.3.512L198.2,214.044l-29.632-17.152v20.3Z",
    transform: "translate(-167.44 -195.22)",
    fill: "#0c1859"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3389_",
    d: "M250.137,214.173l-14.771,8.5-24.557-9.058c-1.057-.362-3.066-1.145-6.026-2.321s-5.392-2.2-7.28-3.044c1.208.889,2.628,2.02,4.289,3.421,1.661,1.387,3.141,2.683,4.486,3.873s6.721,6.059,16.145,14.6l-14.771,8.5-57.663-20.03,12.052-6.933,28.2,10.46q9.4,3.436,14.574,5.7-2.809-2.1-7.28-5.893t-7.189-6.42L176.933,203.11l11.569-6.662,21.431,7.792c3.474,1.221,7.4,2.7,11.765,4.4q6.547,2.577,9.605,3.934-3.1-2.261-9.923-8.3l-18.108-16.338L215.325,181Z",
    transform: "translate(-149.341 -180.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2518_",
    d: "M210.819,216.61l24.557,9.058,14.771-8.5L215.3,183.98l-11.463,6.6v.859l17.534,15.81c4.546,4.039,7.869,6.8,9.923,8.3q-3.058-1.356-9.605-3.934c-4.365-1.718-8.276-3.18-11.765-4.4L188.5,199.428l-10.995,6.33v.859l12.822,11.876q2.719,2.622,7.189,6.421t7.28,5.893q-5.188-2.261-14.574-5.7l-28.2-10.46-12.052,6.933,57.663,20.03,14.771-8.5q-14.136-12.8-16.145-14.6c-1.344-1.191-2.839-2.487-4.486-3.873-1.661-1.387-3.081-2.532-4.289-3.421,1.9.844,4.319,1.869,7.28,3.044C207.753,215.465,209.762,216.233,210.819,216.61Z",
    transform: "translate(-149.351 -178.75)",
    fill: "#f6cf85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3252_",
    d: "M215.6,180.51l-12.717,7.325v.588l18.3,16.519c2.583,2.276,4.772,4.175,6.57,5.652-1.6-.663-3.489-1.417-5.648-2.261-4.319-1.7-8.291-3.18-11.78-4.416l-21.688-7.882L176.549,203v.588l13.577,12.585c1.812,1.748,4.244,3.919,7.219,6.451,1.435,1.221,2.734,2.306,3.927,3.271-2.93-1.176-6.494-2.547-10.632-4.054l-28.454-10.55-12.566,7.249-.06,19.307L207.872,258.1l15.284-8.8.06-19.156s-15.012-13.595-16.341-14.77c-1.344-1.206-2.839-2.5-4.5-3.888-.287-.241-.574-.482-.846-.708,1.012.422,2.1.859,3.262,1.326,2.93,1.176,4.969,1.959,6.041,2.336l24.18,8.907-.06,18.568.634.226,15.284-8.8.06-19.141Zm-8.367,71.982-.015,4.145-56.5-19.623.045-17.332,56.5,19.638Zm3.972-39.171c-1.072-.377-3.081-1.145-6-2.321-2.915-1.161-5.362-2.185-7.264-3.044l-4.924-2.2,4.335,3.2c1.193.874,2.628,2.02,4.259,3.391,1.646,1.387,3.141,2.668,4.47,3.873q1.971,1.763,15.541,14.062l-13.849,7.973-56.213-19.533,10.708-6.164,27.94,10.354c6.207,2.276,11.1,4.19,14.544,5.682l4.621,2.02-4.048-3.014c-1.858-1.387-4.3-3.361-7.249-5.863-2.96-2.517-5.377-4.672-7.174-6.405l-12.822-11.892,10.648-6.134,21.189,7.7c3.474,1.221,7.431,2.713,11.75,4.4,4.319,1.7,7.551,3.014,9.59,3.919l5.014,2.231-4.44-3.225c-2.039-1.477-5.361-4.265-9.877-8.274l-17.519-15.81,10.98-6.33L249.39,214.27l-1.525.889-12.324,7.1Z",
    transform: "translate(-149.56 -180.51)",
    fill: "#0c1859"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3491_",
    transform: "translate(15.973 25.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3490_",
    d: "M187.458,218.877c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,187.458,218.877Z",
    transform: "translate(-135.697 -167.799)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3489_",
    d: "M190,217.407c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,190,217.407Z",
    transform: "translate(-134.401 -168.545)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3488_",
    d: "M192.548,215.951c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,192.548,215.951Z",
    transform: "translate(-133.1 -169.289)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3483_",
    d: "M195.088,214.481c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,195.088,214.481Z",
    transform: "translate(-131.804 -170.035)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3482_",
    d: "M182.368,218.877c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,182.368,218.877Z",
    transform: "translate(-138.294 -167.799)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3481_",
    d: "M184.908,217.407c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,184.908,217.407Z",
    transform: "translate(-136.998 -168.545)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3479_",
    d: "M187.458,215.951c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,187.458,215.951Z",
    transform: "translate(-135.697 -169.289)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3478_",
    d: "M190,214.481c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,190,214.481Z",
    transform: "translate(-134.401 -170.035)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3477_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(57.666 42.05)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3476_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(38.456 48.681)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3475_",
    d: "M182.368,215.951c.408.241.408.618,0,.844a1.619,1.619,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,182.368,215.951Z",
    transform: "translate(-138.294 -169.289)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3471_",
    d: "M184.908,214.481c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,184.908,214.481Z",
    transform: "translate(-136.998 -170.035)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3466_",
    d: "M187.458,213.011a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,187.458,213.011Z",
    transform: "translate(-135.697 -170.78)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3461_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(53.83 39.834)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3460_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(34.604 46.481)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3458_",
    d: "M179.828,214.481c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,179.828,214.481Z",
    transform: "translate(-139.591 -170.035)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3453_",
    d: "M184.908,211.541c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,184.908,211.541Z",
    transform: "translate(-136.998 -171.526)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3452_",
    d: "M187.458,210.067c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,187.458,210.067Z",
    transform: "translate(-135.697 -172.267)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3451_",
    d: "M190,208.6c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,190,208.6Z",
    transform: "translate(-134.401 -173.013)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3449_",
    d: "M174.738,214.481c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,174.738,214.481Z",
    transform: "translate(-142.188 -170.035)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3448_",
    d: "M177.278,213.011a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.574,1.574,0,0,1,177.278,213.011Z",
    transform: "translate(-140.892 -170.78)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3447_",
    d: "M184.908,208.6c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,184.908,208.6Z",
    transform: "translate(-136.998 -173.013)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3440_",
    d: "M187.458,207.127c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.667,1.667,0,0,1,187.458,207.127Z",
    transform: "translate(-135.697 -173.758)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3436_",
    d: "M169.648,214.481c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,169.648,214.481Z",
    transform: "translate(-144.785 -170.035)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3428_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(26.917 42.05)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3427_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(30.768 39.834)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3426_",
    d: "M182.368,207.127c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.667,1.667,0,0,1,182.368,207.127Z",
    transform: "translate(-138.294 -173.758)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3423_",
    d: "M184.908,205.657c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,184.908,205.657Z",
    transform: "translate(-136.998 -174.504)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3422_",
    d: "M167.1,213.011a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.574,1.574,0,0,1,167.1,213.011Z",
    transform: "translate(-146.086 -170.78)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3421_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(23.081 39.834)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3419_",
    d: "M172.188,210.067a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,172.188,210.067Z",
    transform: "translate(-143.489 -172.267)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3418_",
    d: "M179.828,205.657c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,179.828,205.657Z",
    transform: "translate(-139.591 -174.504)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3417_",
    d: "M182.368,204.2c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,182.368,204.2Z",
    transform: "translate(-138.294 -175.248)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3416_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(15.363 39.804)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3415_",
    d: "M167.078,210.061a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,167.078,210.061Z",
    transform: "translate(-146.097 -172.276)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3412_",
    d: "M169.618,208.591c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.573,1.573,0,0,1,169.618,208.591Z",
    transform: "translate(-144.801 -173.022)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3411_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(34.574 28.742)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3410_",
    d: "M179.8,202.707c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,179.8,202.707Z",
    transform: "translate(-139.606 -176)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3409_",
    d: "M182.348,201.237a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.667,1.667,0,0,1,182.348,201.237Z",
    transform: "translate(-138.305 -176.746)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3408_",
    d: "M161.988,210.061a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,161.988,210.061Z",
    transform: "translate(-148.694 -172.276)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3407_",
    d: "M164.538,208.591c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.573,1.573,0,0,1,164.538,208.591Z",
    transform: "translate(-147.393 -173.022)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3406_",
    d: "M174.708,202.707c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,174.708,202.707Z",
    transform: "translate(-142.203 -176)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3393_",
    d: "M177.258,201.237a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.667,1.667,0,0,1,177.258,201.237Z",
    transform: "translate(-140.902 -176.746)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3392_",
    d: "M179.8,199.767c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,179.8,199.767Z",
    transform: "translate(-139.606 -177.491)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3391_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(3.84 37.604)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3388_",
    d: "M159.448,208.591c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.573,1.573,0,0,1,159.448,208.591Z",
    transform: "translate(-149.99 -173.022)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3387_",
    d: "M161.988,207.121a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.574,1.574,0,0,1,161.988,207.121Z",
    transform: "translate(-148.694 -173.767)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3386_",
    d: "M174.708,199.767c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,174.708,199.767Z",
    transform: "translate(-142.203 -177.491)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3385_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(34.574 19.895)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3384_",
    d: "M154.358,208.591c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.573,1.573,0,0,1,154.358,208.591Z",
    transform: "translate(-152.588 -173.022)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3380_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(3.84 33.173)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3379_",
    d: "M159.448,205.651c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,159.448,205.651Z",
    transform: "translate(-149.99 -174.513)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3366_",
    d: "M172.168,198.311c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,172.168,198.311Z",
    transform: "translate(-143.499 -178.235)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3365_",
    d: "M174.708,196.841c.408.241.408.618,0,.844a1.619,1.619,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,174.708,196.841Z",
    transform: "translate(-142.203 -178.981)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3355_",
    d: "M206.353,210.935a.444.444,0,0,1,0-.844,1.574,1.574,0,0,1,1.465,0C208.226,210.317,206.761,211.176,206.353,210.935Z",
    transform: "translate(-125.308 -172.261)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3354_",
    d: "M205.278,208.617c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,205.278,208.617Z",
    transform: "translate(-126.604 -173.003)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3353_",
    d: "M207.818,207.147c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.667,1.667,0,0,1,207.818,207.147Z",
    transform: "translate(-125.308 -173.748)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3344_",
    d: "M210.368,205.677c.408.241.408.618,0,.844a1.619,1.619,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,210.368,205.677Z",
    transform: "translate(-124.006 -174.494)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3337_",
    d: "M212.908,204.221c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,212.908,204.221Z",
    transform: "translate(-122.71 -175.238)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3333_",
    d: "M202.728,207.147c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.667,1.667,0,0,1,202.728,207.147Z",
    transform: "translate(-127.905 -173.748)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3332_",
    d: "M205.278,205.677c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,205.278,205.677Z",
    transform: "translate(-126.604 -174.494)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3331_",
    d: "M207.818,204.221c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,207.818,204.221Z",
    transform: "translate(-125.308 -175.238)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3328_",
    d: "M210.368,202.751a.444.444,0,0,1,0,.844,1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,210.368,202.751Z",
    transform: "translate(-124.006 -175.984)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3327_",
    d: "M196.173,207.151a1.574,1.574,0,0,1,1.465,0,.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0C195.766,207.769,195.766,207.392,196.173,207.151Z",
    transform: "translate(-130.502 -173.752)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3326_",
    d: "M200.188,205.677c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,200.188,205.677Z",
    transform: "translate(-129.201 -174.494)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3324_",
    d: "M202.728,204.221c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,202.728,204.221Z",
    transform: "translate(-127.905 -175.238)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3323_",
    d: "M205.278,202.751a.444.444,0,0,1,0,.844,1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,205.278,202.751Z",
    transform: "translate(-126.604 -175.984)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3322_",
    d: "M207.818,201.281c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,207.818,201.281Z",
    transform: "translate(-125.308 -176.729)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3314_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(84.58 22.155)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3313_",
    d: "M193.62,205.691a1.574,1.574,0,0,1,1.465,0,.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0A.45.45,0,0,1,193.62,205.691Z",
    transform: "translate(-131.8 -174.493)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3312_",
    d: "M197.638,204.221c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,197.638,204.221Z",
    transform: "translate(-130.502 -175.238)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3311_",
    d: "M202.728,201.281c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,202.728,201.281Z",
    transform: "translate(-127.905 -176.729)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3298_",
    d: "M205.278,199.811c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,205.278,199.811Z",
    transform: "translate(-126.604 -177.475)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3297_",
    d: "M207.818,198.337c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,207.818,198.337Z",
    transform: "translate(-125.308 -178.216)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3296_",
    d: "M191.083,204.221a1.574,1.574,0,0,1,1.465,0,.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0C190.676,204.824,190.676,204.447,191.083,204.221Z",
    transform: "translate(-133.1 -175.238)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3293_",
    d: "M195.1,202.751a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,195.1,202.751Z",
    transform: "translate(-131.799 -175.984)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3292_",
    d: "M198.723,199.811a1.574,1.574,0,0,1,1.465,0c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0A.444.444,0,0,1,198.723,199.811Z",
    transform: "translate(-129.201 -177.475)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3291_",
    d: "M202.728,198.337c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,202.728,198.337Z",
    transform: "translate(-127.905 -178.216)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3290_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(76.892 17.724)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3289_",
    d: "M188.529,202.751a1.574,1.574,0,0,1,1.465,0,.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0A.45.45,0,0,1,188.529,202.751Z",
    transform: "translate(-134.397 -175.984)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3286_",
    d: "M192.558,201.281c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,192.558,201.281Z",
    transform: "translate(-133.095 -176.729)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3284_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(69.205 17.724)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3283_",
    d: "M202.728,195.4c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,202.728,195.4Z",
    transform: "translate(-127.905 -179.707)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3279_",
    d: "M185.993,201.281a1.574,1.574,0,0,1,1.465,0c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0C185.586,201.9,185.586,201.522,185.993,201.281Z",
    transform: "translate(-135.697 -176.729)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3277_",
    d: "M190.008,199.811a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.574,1.574,0,0,1,190.008,199.811Z",
    transform: "translate(-134.396 -177.475)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3269_",
    d: "M197.638,195.4c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,197.638,195.4Z",
    transform: "translate(-130.502 -179.707)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3268_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(69.205 13.308)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3267_",
    d: "M202.728,192.471c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.574,1.574,0,0,1,202.728,192.471Z",
    transform: "translate(-127.905 -181.197)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3266_",
    d: "M183.42,199.8a1.574,1.574,0,0,1,1.465,0,.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0A.45.45,0,0,1,183.42,199.8Z",
    transform: "translate(-137.005 -177.48)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3256_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(61.487 13.278)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3255_",
    d: "M197.618,192.447c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,197.618,192.447Z",
    transform: "translate(-130.513 -181.204)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3254_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(69.175 8.847)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3251_",
    d: "M180.883,198.331a1.574,1.574,0,0,1,1.465,0,.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0C180.476,198.934,180.476,198.557,180.883,198.331Z",
    transform: "translate(-138.305 -178.225)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3250_",
    d: "M192.528,192.447c.408.241.408.618,0,.844a1.574,1.574,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,192.528,192.447Z",
    transform: "translate(-133.11 -181.204)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3249_",
    d: "M195.078,190.977a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.667,1.667,0,0,1,195.078,190.977Z",
    transform: "translate(-131.809 -181.949)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3247_",
    d: "M197.618,189.507c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,197.618,189.507Z",
    transform: "translate(-130.513 -182.695)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3245_",
    d: "M178.329,196.861a1.574,1.574,0,0,1,1.465,0,.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0A.45.45,0,0,1,178.329,196.861Z",
    transform: "translate(-139.602 -178.971)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3244_",
    d: "M192.528,189.507c.408.241.408.618,0,.844a1.667,1.667,0,0,1-1.465,0c-.408-.241-.408-.618,0-.844A1.667,1.667,0,0,1,192.528,189.507Z",
    transform: "translate(-133.11 -182.695)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3243_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(61.487 4.431)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3242_",
    d: "M175.793,195.391a1.574,1.574,0,0,1,1.465,0,.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0C175.386,196.009,175.386,195.632,175.793,195.391Z",
    transform: "translate(-140.902 -179.716)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3241_",
    d: "M189.988,188.051a.444.444,0,0,1,0,.844,1.574,1.574,0,0,1-1.465,0,.444.444,0,0,1,0-.844A1.574,1.574,0,0,1,189.988,188.051Z",
    transform: "translate(-134.406 -183.439)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3240_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(57.651 2.216)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3222_",
    cx: 1.042,
    cy: 0.603,
    rx: 1.042,
    ry: 0.603,
    transform: "translate(61.487)",
    fill: "#0c1859"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiteraW);
export default __webpack_public_path__ + "static/media/Litera W.cb823688d1ae4cf99b48b582712e1046.svg";
export { ForwardRef as ReactComponent };